import { Button, Card, Form, Input, Upload } from "antd";
import React, { useEffect, useState } from "react";
import addImgRectangle from "../../assets/images/icons/add_img_rectangle.png.png";
import AddImageModal from "../../components/AddImageModal";
import bellboy_icon from "../../assets/images/icons/bellboyname_grey@3x.png";
import { useDispatch, useSelector } from "react-redux";
import toastr from "toastr";
import { createBellboyAction } from "../../store/actions/bellboy.action";
import Congratulations from "../../components/congratulations";
import { useNavigate } from "react-router-dom";
const AddNewBellboy = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [fileList, setFileList] = useState([]);
  const [imgVisible, setImgVisible] = useState(false);
  const [visible, setVisible] = useState(false);
  const [state, setState] = useState({});
  const [bellboyName, setBellboyName] = useState("");
  const [arabicName, setArabicName] = useState("");
  const [orgId, setOrgId] = useState("");
  const [userId, setUserId] = useState("");
  const [callingApi, setCallingApi] = useState(false);

  const currentUser = useSelector((state) => state?.user?.currentUser);

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handlePopupModal = () => {
    setImgVisible(true);
  };

  const handleDeleteImage = () => {
    setFileList([]);
  };

  const hideImgModal = () => {
    setImgVisible(false);
  };

  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    getBase64(newFileList.slice(-1)[0]?.originFileObj, (imageUrl) =>
      setState({
        imageUrl,
      })
    );
  };

  const showModal = () => {
    setVisible(true);
  };

  const hideModal = () => {
    setVisible(false);
    navigate("/havenly/bellboy", { state: { id: orgId } });
  };

  useEffect(() => {
    setOrgId(currentUser?.organization_id);
    setUserId(currentUser?.id);
  }, [currentUser]);

  const onSubmit = async (values) => {
    setCallingApi(true);
    const file = fileList.slice(-1);
    let fd = new FormData();
    fd.append("name", values?.name);
    fd.append("ar_name", values?.arabicName);
    fd.append("image", file[0]?.originFileObj);
    fd.append("organization_id", orgId);
    fd.append("created_by", userId);
    const res = await dispatch(createBellboyAction(fd));
    if (res.statusCode === 200) {
      setCallingApi(false);
      showModal();
    } else if (Object.keys(res)?.length === 0) {
      setCallingApi(false);
      showModal();
    } else {
      setCallingApi(false);
      toastr.error(res?.response?.data?.message);
    }
  };

  return (
    <>
      <Card style={{ width: "50%" }}>
        <p className="sm-title-card mtt-10">General Information</p>
        <p className="sub-heading">Add Photo of Bellboy</p>
        <Form
          name="normal_login"
          className="login-form"
          initialValues={{
            remember: true,
            name: bellboyName,
            arabicName: arabicName,
            image: fileList[0]?.thumbUrl,
          }}
          onFinish={onSubmit}
        >
          <Form.Item
            name="image"
            rules={[
              {
                required: false,
                message: "Please enter image",
              },
            ]}
          >
            {fileList.length === 0 ? (
              <>
                <div className="rectangle-frame-img">
                  <img
                    alt=""
                    src={addImgRectangle}
                    className="upload-img-box mtt-20"
                    onClick={handlePopupModal}
                  />
                  <p className="img-warn mtt-10">Files Supported: PNG, JPEG</p>
                  <p className="img-warn mtt-10">Image Size (200x200)</p>
                </div>
              </>
            ) : (
              <>
                <Upload
                  disabled={true}
                  listType="picture-card"
                  fileList={fileList.slice(-1)}
                  beforeUpload={() => false}
                  onPreview={handlePopupModal}
                >
                  {fileList.length < 1 && "+"}
                </Upload>
                <p className="img-warn mt-1">Files Supported: PNG, JPEG</p>
                <p className="img-warn mtt-10">Image Size (200x200)</p>
              </>
            )}
          </Form.Item>
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
                message: "Please input Name!",
              },
            ]}
          >
            <Input
              maxLength={23}
              style={{ width: "80%" }}
              className={"inputfield"}
              defaultValue={bellboyName}
              prefix={
                <img
                  alt=""
                  src={bellboy_icon}
                  className="site-form-item-icon input-icon-field-twenty"
                />
              }
              placeholder="Bellboy Name"
              onChange={(e) => {
                setBellboyName(e.target.value);
              }}
            />
          </Form.Item>
          <Form.Item
            name="arabicName"
            rules={[
              {
                required: true,
                message: "Please input arabic name!",
              },
            ]}
          >
            <Input
              maxLength={23}
              style={{ width: "80%" }}
              className={"inputfield"}
              defaultValue={arabicName}
              lang={"ar"}
              dir={"rtl"}
              suffix={
                <img
                  alt=""
                  src={bellboy_icon}
                  className="site-form-item-icon input-icon-field-twenty"
                />
              }
              placeholder="اسم بيلبوي"
              onChange={(e) => {
                setArabicName(e.target.value);
              }}
            />
          </Form.Item>
          <Form.Item>
            <div className="d-flex justify-content-end mtt-10">
              <Button
                className="servicesMainBtn"
                htmlType="submit"
                style={{ margin: "0 12px" }}
                disabled={callingApi}
              >
                {callingApi ? "Loading..." : "Save"}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Card>
      <Congratulations
        visible={visible}
        hideModal={hideModal}
        message={"Your Bellboy has been successfully created!"}
      />
      <AddImageModal
        handleDeleteImage={handleDeleteImage}
        file={fileList}
        state={state}
        visible={imgVisible}
        hideModal={hideImgModal}
        onChange={onChange}
      />
    </>
  );
};

export default AddNewBellboy;
